import React, { PropTypes, Component } from 'react';

import { LoadingIndicator } from 'common/components/preloader';
import ModalDialog from 'common/components/modal/modal_dialog';
import AddParticipants from 'focus_groups/containers/participants';
import ParticipantRow from 'focus_groups/containers/participant_row';

export default class ParticipantList extends Component {
  constructor(props) {
    super(props);
    this.onToggle = this.onToggle.bind(this);
  }

  onToggle() {
    this.props.toggleAddParticipants();
  }

  render() {
    const { group, showAddParticipants } = this.props;

    if (!group) {
      return <LoadingIndicator />;
    }

    return (<div className="tab-content participants">
              <div className="tab-actions">
                <button className="btn btn-secondary btn-sm " onClick={this.onToggle}>
                  Add Participants
                </button>
              </div>
              <ModalDialog
                dialogClasses="focus-group-modal add-participants-modal"
                modalOpen={showAddParticipants}
                closeAction={this.onToggle}
                modalHeader={group.name}
              >
                <AddParticipants />
              </ModalDialog>
              <table className="table table-default participants-table">
                <thead>
                  <tr>
                    <td>Email</td>
                    { group.weight_votes &&
                    <td>Vote Counts</td> }
                    <td className="center">Has Voted</td>
                    <td/>
                  </tr>
                </thead>
                <tbody>
                  {group.participants.map(participant => (
                    <ParticipantRow key={`participant-row-${participant.id}`}
                      isWeighted={group.weight_votes} {...participant} />
                  ))}
                </tbody>
              </table>
            </div>
          );
  }
}

ParticipantList.propTypes = {
  group: PropTypes.shape({
    votes: PropTypes.object,
    revisions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    participants: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  }),
  showAddParticipants: PropTypes.bool,
  toggleAddParticipants: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./focus_groups/components/participant_list.jsx